/*
 * File: payOrder.tsx
 * Project: meki
 * File Created: Monday, 9th November 2020 10:31:19 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Wednesday, 5th October 2022 3:30:13 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { Order, AvailabilityType } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';
import { ReimbursedProduct } from '@queries/userInsurance/queries/getInsuranceQuote';

export const PayOrder = (name: string) => gql`
mutation ${name}($params: PayOrderParams!){
  payOrder(params: $params) {
    id
    uuid
    status
    orderGroupId
    address {
      id
      name
      street
      streetNumber
      commune
    }
  }
}
`;

export interface PayOrderDetails {
  productId: number;
  price: number;
  quantity: number;
  availability: AvailabilityType;
}
export interface PayOrderInfo {
  deliveryDate: string;
  details: PayOrderDetails[];
  reimbursedProductsInfo: ReimbursedProduct[];
}

export type PayOrderMutationParams = ResolverParams<{
  orderUuid: string;
  orders: PayOrderInfo[];
  amount: number;
  useCredits: boolean;
  chargeDeliveryCost: boolean;
  insuranceId: number;
}>;

export type PayOrderMutationResponse = {
  payOrder: Order;
};
